<template>
    <div>
        <BreadCrumb>
            <template>
                <ResearchQuery v-if="type==1||type==2"></ResearchQuery>
                <el-breadcrumb-item v-if="type==1"><router-link to="/research">最新研究</router-link></el-breadcrumb-item>
                <el-breadcrumb-item v-if="type==2"><router-link to="/articleList/2?topic=">新闻热点</router-link></el-breadcrumb-item>
                <el-breadcrumb-item v-if="type==2"><router-link :to="'/articleList/2?topic=' + data.topic">{{data.topic}}</router-link></el-breadcrumb-item>
                <el-breadcrumb-item v-if="type==4"><router-link to="/analysis/list/0">统计分析</router-link></el-breadcrumb-item>
                <el-breadcrumb-item v-if="type==4"><router-link :to="'/analysis/list/' + data.sub">{{data.subDesc}}</router-link></el-breadcrumb-item>
                <el-breadcrumb-item v-if="type==4"><router-link :to="'/analysis/list/' + data.category">{{data.categoryDesc}}</router-link></el-breadcrumb-item>
                <el-breadcrumb-item>文章详情</el-breadcrumb-item>
            </template>
        </BreadCrumb>
        <div class="box" v-loading="data==null" element-loading-background="rgba(0, 0, 0, 0.8)">
            <h3 v-if="type!=1" ref="title" style="line-height: 26px; font-size: 16px; padding: 20px 20px;">
                <b v-if="data!=null">{{data.title}}</b>
            </h3>
            <h3 v-if="type==1" ref="title" style="line-height: 26px; font-size: 16px; padding: 20px 20px; color: rgb(0, 112, 192);">
                <b v-if="data!=null">{{data.title}}</b>
                <span>
                    <br v-show="!isTitleMultiLine"/><span v-show="isTitleMultiLine">&nbsp;&nbsp;</span>
                <span v-if="data!=null">{{data.localizedTitle}}</span>
                </span>
            </h3>
            <div v-if="data!=null" style="position: relative;padding-top: 10px;">
                <a v-if="isCol==false" class="fav-button" @click="addCollection" style="font-weight: bold;">
                    <i class="fa fa-star-o" aria-hidden="true" style="margin-right: 5px; color: #14aab9; "></i>收藏
                </a>
                <a v-if="isCol==true" class="fav-button" @click="removeCollection" style="font-weight: bold;">
                    <i class="fa fa-star" aria-hidden="true" style="margin-right: 5px; color: #14aab9; "></i>取消收藏
                </a>
                <div v-if="type==1" style="line-height: 30px;padding-top: 0;">
                    <b>发表日期：</b>{{data.date}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>作者：</b>{{ shortAuthor }}
                    &nbsp;&nbsp;&nbsp;&nbsp;<a v-if="data.doi!=''" :href="'https://doi.org/'+data.doi" target="_blank" style="position: absolute; right: 130px; line-height:20px;font-weight: bold;">
                    <i class="fa fa-link" aria-hidden="true" style="margin-right: 5px; color: #14aab9; "></i>原文链接</a>
                    <br/>
                    <b>来源：</b>{{data.source}}<br/>
                    {{data.author.split(' ')[0]}} et al. {{data.source}}. {{data.date.split('-')[0]}},{{data.volume}}({{data.issue}}):{{data.page}}. <b>DOI：</b>{{data.doi}}.<br/>
                    <b>摘要：</b>
                    <el-row>
                        <el-col :span="12">
                            <div ref="para-en" style="text-align: justify; padding: 0;line-height: 26px;" v-html="data.summary"></div>
                        </el-col>
                        <el-col :span="12">
                            <div ref="para-cn" style="text-align: justify; padding: 0;color: #0070c0" :style="{'line-height': lineHeightCn+'px'}" v-html="data.localizedSummary"></div>
                        </el-col>
                    </el-row>

                </div>
                <div v-if="type==2">
                    <b>日期：</b>{{data.date}}&nbsp;&nbsp;&nbsp;&nbsp;
                    <b>来源：</b><a :href="data.url" target="_blank">{{data.source}}</a>
                    <br/>
                    <div class="article-news-detail" style="text-align: justify; padding-top: 20px" v-html="data.content"></div>
                    <br/><br/>
                    <div style="color: #404040;">本网站所有文章系转载文章，是出于传递更多信息之目的，转载内容不代表本站立场。不希望被转载的媒体或个人可与我们联系，我们将立即进行删除处理。</div>
                </div>
                <div v-if="type==3">
                    <b>分类：</b>{{data.type}}
                    <br/>
                    <div style="text-align: justify;" v-html="data.content"></div>
                </div>
                <div v-if="type==4" style="line-height: 1.8;" class="mengte">
                    <div>
                        <b>日期：</b>{{data.date}}&nbsp;&nbsp;&nbsp;&nbsp;
                        <b>来源：</b><a :href="data.url" target="_blank">{{data.source}}</a>
                    </div>
                    <div style="margin: 10px 10px; width: auto; padding-top: 30px;">
                        <div v-if="data.summary!=''&&data.summary!=null" style="padding: 15px 20px; text-align: left; background: rgba(7, 193, 96, .08);">{{data.summary}}</div>
                        <div v-if="data.keyword!=''&&data.keyword!=null" style="padding: 15px 20px; margin: 0 0 25px; font-size: 14px; background: #f3f3f3; margin-top: 16px;">{{data.keyword}}</div>
                    </div>
                    <div style="text-align: justify; line-height: 26px;" v-html="data.content"></div>
                    <br/>
                    <!-- <b>来源：</b>{{ data.source }} -->
                </div>
                <div v-if="type==5">
                    <b>来源：</b>{{data.source}}
                    <br/>
                    <div style="text-align: justify;" v-html="data.content"></div>
                </div>
            </div>
            <div v-if="data==null">
                <el-skeleton :rows="8" />
            </div>
        </div>
    </div>

</template>

<script>
import request from '@/utils/request'
import BreadCrumb from './BreadCrumb.vue'
import ResearchQuery from "./ResearchQuery";
import {eventBus} from "../main";

export default {
    props: ["id", "type"],
    created() {
        this.fetchData();
    },
    watch: {
        // 如果路由有变化，会再次执行该方法
        "$route": "fetchData"
    },
    data() {
        return {
            data: null,
            typeName: null,
            isCol: false,
            isTitleMultiLine: false,
            lineHeightCn: 20,
        };
    },
    computed: {
        shortAuthor() {
            let arr = this.data.author.split(' ')
            let str = arr[0] + ' ' + arr[1] + '......' + arr[arr.length - 3] + ' ' + arr[arr.length - 2]
            return str
        },
    },
    methods: {
        fetchData() {
            this.data = null;
            this.isCol = false
            this.lineHeightCn = 20;

            request({
                url: "api/article?type=" + this.type + "&id=" + this.id,
                method: "get"
            }).then((r) => {
                this.data = r;

                if(this.data) {
                    let title = this.data.localizedTitle || this.data.title
                    document.title = title + ' - 灯塔索引';
                }

                this.$nextTick(() => {
                    this.isTitleMultiLine = this.$refs.title.firstElementChild.offsetHeight > 24;

                    if(this.type == 1) {
                        // console.log('para height', this.$refs["para-en"].offsetHeight, this.$refs["para-cn"].offsetHeight)
                        this.lineHeightCn = Math.floor(20 * this.$refs["para-en"].offsetHeight / this.$refs["para-cn"].offsetHeight)
                    }
                })
            }).catch(error => {
                console.log(error);
            });

            // if(this.global.account != null) {
                request({
                    url: "api/user/iscol",
                    method: "post",
                    data: {
                        token: this.global.account.token,
                        type: this.type,
                        id: this.id
                    }
                }).then((r) => {
                    // console.log(r);
                    this.isCol = r
                }).catch(error => {
                    console.log(error);
                });
            // }
        },
        recoverFormat(v) {
            // console.log(v.replace("'", "\\'").replace("\\n", "").replace("\n", ""))
            return eval("'" + v.replace("'", "\\'").replace("\\n", "") + "'");
            // return eval("'<p>研究者Xiaowei Zhuang表示，理解机体衰老是生物医学领域科学家们的一个重要目标之一，同时这也是一个非常有挑战性的问题，原因之一在于大脑非常复杂，其包含了异常高的细胞多样性，以及多种不同类型的神经元和非神经元细胞所形成的复杂互作网络。为了研究诸如这样一种复杂的系统，研究人员利用名为MERFISH的成像方法进行研究，MERFISH，即多重错误强大的荧光原位杂交方法（Multiplexed Error Robust Fluorescence In Situ Hybridization），其能同时测定成千上万种RNA或成千上万个基因，而且还能揭示其之间的空间关系。</p> \\n" +
            //     "<p>研究者表示，MERFISH方法能帮助科学家们产生基因表达图谱，并查看邻近的关系；在该方法的帮助下，研究人员不仅能够观察不同年龄个体机体中的基因表达改变，还能观察特定基因表达的改变，这或许与空间关系有关。将这种大局策略应用于小鼠的大脑，研究人员就识别出了神经元细胞和非神经元细胞是如何在机体衰老过程中发生改变的，尤其是，本文研究还表明，衰老和炎症会以一种相似和不同的方式，以及以一种空间依赖性的方式影响细胞中基因的表达方式。</p> '");
            // return v.replace("。  ", "。<br/><br/>").replace("。 ", "。<br/>").replace("。 ", "。<br/>");
        },
        addCollection() {
            if(this.global.account == null) {
                this.$message({
                    message: '请先登录',
                    type: 'warning'
                });
                eventBus.$emit('show-login', '');
                return;
            }
            request({
                url: "api/user/ccol",
                method: "post",
                data: {
                    token: this.global.account.token,
                    type: this.type,
                    id: this.id
                }
            }).then((r) => {
                // console.log(r);
                this.isCol = true
            }).catch(error => {
                console.log(error);
            });
        },
        removeCollection() {
            request({
                url: "api/user/dcol",
                method: "post",
                data: {
                    token: this.global.account.token,
                    type: this.type,
                    id: this.id
                }
            }).then((r) => {
                // console.log(r);
                this.isCol = false
            }).catch(error => {
                console.log(error);
            });
        }
    },
    components: {ResearchQuery, BreadCrumb }
}
</script>

<style scoped>
.fav-button {
    right: 40px;
    top: 10px;
    position: absolute;
}
.box { width: 913px; background: #fff; overflow: hidden; border:#e8e8e8 1px solid;/*  position: relative; */}
.box div { overflow: hidden; padding: 0 20px 20px 20px;}
/* .mzdh h3 i { display:block; margin:0; padding:0; position: absolute; top:0; right: 10px; z-index: 100;} */
.box h3 { line-height: 54px; color: #666; font-size: 18px; padding: 0 20px; border-bottom: #e8e8e8 1px solid;}

</style>

<style>

.article-news-detail{
    padding-bottom:100%;
}

.article-news-detail img {
    width: 780px;
    margin: 20px auto;
    display: block;
    border-radius: 5px;
    box-shadow: 0 0 5px #ccc;
    cursor: pointer;
}

.article-news-detail table {
    border-collapse: collapse;
    width: 780px;
    margin: 0 auto;
}

.article-news-detail td,.article-news-detail th {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: center;
}

.article-news-detail th {
    background-color: #f5f5f5;
}

.article-news-detail p {
    margin-bottom: 15px;
    line-height: 26px;
    text-align: justify;
    text-indent: 32px;
}

.mengte h2.toc-index {
    position: relative;
    padding: 3px 0 6px;
    margin: 20px 0;
    font-size: 19px;
    font-weight: 700;
}

.mengte h2.toc-index::after {
    position: absolute;
    content: '';
    left: 0;
    right: 0;
    bottom: 0;
    height: 2px;
    background-color: rgba(7, 193, 96, .55);
    background-image: linear-gradient(to right, rgb(7, 193, 96), rgb(230, 249, 239)) !important;
}

.mengte .wp-block-image .aligncenter {
    margin-left: auto;
    margin-right: auto;
}

.mengte .aligncenter {
    clear: both;
    display: table;
}

.mengte .wp-block-image figcaption {
    margin: 8px 0 0;
    text-align: center;
    font-size: 12px;
    color: #999;
}

.mengte .wp-block-image img {
    max-width: 100%;
    height: auto;
    border-radius: 5px;
    box-shadow: 0 0 5px #ccc;
    cursor: pointer;
}

.mengte p {
    margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/ArticleDetail.vue